import { PageConfig } from '../../../config/mainPageConfig';

export interface PageState {
    loading: boolean;
    pageName: string;
    formData: Record<string, unknown>;
    pageConfig: Partial<PageConfig>;
    isFormSubmitting: boolean;
    isFormReadOnly: boolean;
    apiError?: unknown;
}

export const initialPageState: PageState = {
    loading: false,
    pageName: '',
    formData: {},
    pageConfig: {},
    isFormSubmitting: false,
    isFormReadOnly: true
};
